import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';

interface ProgressLogCardProps {
  messages: string[];
}

const ProgressLogCard: React.FC<ProgressLogCardProps> = ({ messages }) => {
  const { t } = useTranslation();

  return (
    <Card className="mb-6">
      <CardContent className="p-4 pb-6">
        <p className="revy-cjk mb-2 text-base leading-[1.75]">
          {t('drbfm.processing.progressLog')}
        </p>
        <Separator className="mb-4" />
        <div className="max-h-[200px] overflow-auto rounded-md border bg-muted/50 p-4">
          {messages.map((message, index) => (
            <p
              key={index}
              className="revy-cjk mb-1 font-mono text-[0.8rem] leading-[1.5] text-muted-foreground"
            >
              {message}
            </p>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProgressLogCard;
